<template>
    <div class="bg-background text-foreground min-h-screen">
        <SeoHead v-if="page.props.seo" :seo="page.props.seo" />
        <header
            class="mx-auto flex max-w-4xl items-center justify-between border-b px-6 py-6"
        >
            <Link :href="home().url" class="font-semibold">LaunchStation</Link>
            <Link :href="index('blog').url" class="text-sm">Blog</Link>
        </header>
        <main class="mx-auto max-w-4xl px-6 py-12"><slot /></main>
    </div>
</template>
<script setup lang="ts">
import { Link, usePage } from '@inertiajs/vue3';
import SeoHead from '@/components/blog/SeoHead.vue';
import { home } from '@/routes';
import { index } from '@/routes/blog';
import type { SeoData } from '@/types/blog';
const page = usePage<{ seo: SeoData }>();
</script>
